import { useEffect } from 'react';

/**
 * 페이지 마운트 시 스크롤을 상단으로 이동
 */
export const useScrollTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};
